import {marineHubAPI, RestQueryParams} from 'marine-panel-common-web';
import {Observable} from 'rxjs';

export function unassignOperatorFromMarinaAPI(authToken: string | null, marinaId: string, operatorId: string): Observable<any> {
    const headers = {
            Authorization: `Bearer ${authToken}`,
        },
        payload = {
            operatorId: operatorId,
        };

    return marineHubAPI.put(`api/marinas/${marinaId}/unassign_operator`, payload, new RestQueryParams(), headers);
}
